import type { DynamicClient } from '../../../../client/types';
import { NoNetworkProvidersError } from '../../../../errors/NoNetworkProvidersError';
import { assertDefined } from '../../../../utils/assertDefined';
import type { Chain } from '../../../chain';
import { getNetworkProviders } from '../getNetworkProviders';
import type { NetworkProvider } from '../networkProvider/networkProvider.types';

type GetNetworkProviderFromNetworkIdProps = {
  chain: Chain;
  networkId: string;
};

export const getNetworkProviderFromNetworkId = (
  { networkId, chain }: GetNetworkProviderFromNetworkIdProps,
  client: DynamicClient
): NetworkProvider => {
  const networkProviders = getNetworkProviders(client);

  if (networkProviders.length === 0) {
    throw new NoNetworkProvidersError();
  }

  const networkProvider = networkProviders.find(
    (networkProvider) =>
      networkProvider.networkId === networkId && networkProvider.chain === chain
  );

  assertDefined(
    networkProvider,
    `No network provider found for chain ${chain} with network id ${networkId}`
  );

  return networkProvider;
};
